import styles from './styles.module.css';

import cn from 'classnames';

export function Joystick(props: IJoystickProps) {
  const { className, size = 'default', onTop, onLeft, onRight, onBottom, ...rest } = props;
  const rootClass = cn(className, styles.root, styles[`root_${size}`]);

  // TODO: заменить символы на иконки, после внедрения механизма иконок-рефакторинга
  return (
    <div className={rootClass} {...rest}>
      <div className={cn(styles.item, styles.top)} onClick={onTop}>
        &#94;
      </div>
      <div className={cn(styles.item, styles.left)} onClick={onLeft}>
        &#60;
      </div>
      <div className={cn(styles.item, styles.bottom)} onClick={onBottom}>
        &#709;
      </div>
      <div className={cn(styles.item, styles.right)} onClick={onRight}>
        &#62;
      </div>
    </div>
  );
}

export interface IJoystickProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'small' | 'default' | 'large';
  onTop: () => void;
  onBottom: () => void;
  onLeft: () => void;
  onRight: () => void;
}
